import React, {useState} from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Card, CardBody, CardFooter, CardHeader, CardHeaderToolbar } from "../../../../../../../_metronic/_partials/controls"
import { kurbanReportStatusKeys } from '../KurbanReportUIHelpers';
import { FinishModal } from './modals/FinishModal';
import { RejectModal } from './modals/RejectModal';
import { UploadImageModal } from './modals/UploadImageModal';

export const KurbanReportStatusActions = ({actionsLoading, submitUpdate, currentStatus}) => {
  const [showFinishModal, setShowFinishModal] = useState(false)
  const [showRejectModal, setShowRejectModal] = useState(false)
  const [showImageModal, setShowImageModal] = useState(false)
  
  function confirmFinish() {
    if(actionsLoading) {
      return;  
    }
    
    const status = kurbanReportStatusKeys.FINISH;
    
    submitUpdate({status});
  }

  function confirmReject(reject_comment) {
    if(actionsLoading) {
      return;  
    }
    
    const status = kurbanReportStatusKeys.EXECUTED;
    
    submitUpdate({status, reject_comment});
  }

  function confirmUpload(image_after, image_before) {
    const updates = {image_after, image_before};
    
    submitUpdate(updates);
  }
  
  return (
    <>
      <FinishModal confirm={confirmFinish} show={showFinishModal} onHide={() => setShowFinishModal(false)} />
      <RejectModal confirm={confirmReject} show={showRejectModal} onHide={() => setShowRejectModal(false)} /> 
      <UploadImageModal confirm={confirmUpload} show={showImageModal} onHide={() => setShowImageModal(false)} /> 
      <CardFooter>
        {currentStatus === kurbanReportStatusKeys.REPORTED && (
          <>
            <button className="btn btn-primary float-right m-2" onClick={() => setShowFinishModal(true)}>Finish</button>
            <button className="btn btn-danger float-right m-2" onClick={() => setShowRejectModal(true)}>Reject</button>
          </>
        )}
        {[kurbanReportStatusKeys.REPORTED, kurbanReportStatusKeys.FINISH].includes(currentStatus) && (
          <button className="btn btn-warning float-right m-2" onClick={() => setShowImageModal(true)}>Ubah Foto</button>
        )}
      </CardFooter>
    </>
  )
}